import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Product } from '../data/models';
import { ErrorNotificationsService } from '../core/error-handling/error-notifications.service';
import { PosSoundService } from '../core/pos-sound.service';

export interface ProductAction {
  id: number;
  action: 'addToCart' | 'openInfo' | 'selectVariant';
}

export interface ProductViewModel extends Product {
  title: string;
  price: number;
  available: boolean;
  considersStock: boolean;
  stock: number;
  image: string | null;
  hasMultipleVariants: boolean;
}

@Component({
    template: ``,
    standalone: false
})
export abstract class ProductBaseComponent {
  @Input() product!: ProductViewModel;
  @Output() productAction: EventEmitter<ProductAction> = new EventEmitter<ProductAction>();

  constructor(
    private readonly errorNotifications: ErrorNotificationsService,
    private readonly sound: PosSoundService,
  ) {}
  addToCart(product: ProductViewModel) {
    this.sound.click();
    if (!this.isProductAvailable()) {
      const message = $localize`Das Produkt ist nicht mehr verfügbar.`;
      this.errorNotifications.showError(message);
      return;
    }
    if (product.hasMultipleVariants) {
      this.productAction.emit({id: product.id, action: 'selectVariant'});
      return;
    }
    this.productAction.emit({id: product.id, action: 'addToCart'});
  }

  openInfo(productId: number) {
    this.productAction.emit({id: productId, action: 'openInfo'});
  }

  isProductAvailable(): boolean {
    return !this.product.considersStock || this.product.stock > 0;
  }
}
